import React, { useState } from "react";
import UpdateCategoryPopup from "./UpdateCategoryPopup";
import { useDispatch } from "react-redux";
import { DeleteCategory } from "../../../RTK/categories/DeleteCategories";
import ConfirmationPopup from "./ConfirmDeletePopup";
import { X, Pencil, Trash2, Info } from 'lucide-react';

const CategoryPopup = ({ categoryType, isVisible, category, onClose }) => {
  const dispatch = useDispatch();
  const [isUpdateVisible, setIsUpdateVisible] = useState(false);
  const [isDeleteConfirmationVisible, setIsDeleteConfirmationVisible] = useState(false);

  if (!isVisible || !category) return null;

  const imageSrc = category.image || category.product_image || category.banner_image || "";
  const desc = category.description || category.product_details || "لا توجد تفاصيل متاحة.";

  const handleUpdateClick = () => {
    setIsUpdateVisible(true);
  };

  const handleDeleteClick = () => {
    setIsDeleteConfirmationVisible(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await dispatch(DeleteCategory({ categoryId: category.id, categoryType })).unwrap();
      onClose();
    } catch (error) {
      console.error("خطأ في حذف الفئة:", error);
    } finally {
      setIsDeleteConfirmationVisible(false);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteConfirmationVisible(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" dir="rtl">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      
      <div className="relative bg-gray-900 w-full max-w-2xl rounded-2xl shadow-xl overflow-hidden border border-gray-800">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute left-4 top-4 p-2 rounded-full bg-gray-800/50 hover:bg-gray-700/50 transition-colors"
        >
          <X className="w-5 h-5 text-gray-400" />
        </button>

        {/* Header */}
        <div className="p-6 border-b border-gray-800">
          <h2 className="text-2xl font-bold text-white">{category.name}</h2>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Image */}
          {imageSrc && (
            <div className="relative group rounded-xl overflow-hidden bg-gray-800">
              <img
                src={imageSrc}
                alt={category.name}
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          )}

          {/* Details */}
          <div className="bg-gray-800/50 rounded-xl p-4">
            <div className="flex items-start gap-3">
              <Info className="w-5 h-5 text-gray-400 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">التفاصيل</h3>
                <p className="text-gray-300 leading-relaxed">{desc}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="p-6 border-t border-gray-800 flex gap-3 justify-end">
          <button
            onClick={handleDeleteClick}
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-red-500/10 text-red-500 hover:bg-red-500/20 transition-colors font-medium"
          >
            <Trash2 className="w-4 h-4" />
            <span>حذف</span>
          </button>

          <button
            onClick={handleUpdateClick}
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-yellow-500/10 text-yellow-500 hover:bg-yellow-500/20 transition-colors font-medium"
          >
            <Pencil className="w-4 h-4" />
            <span>تعديل</span>
          </button>
        </div>
      </div>

      {/* Update Popup */}
      {isUpdateVisible && (
        <UpdateCategoryPopup
          categoryType={categoryType}
          category={category}
          isVisible={isUpdateVisible}
          onClose={() => setIsUpdateVisible(false)}
        />
      )}

      {/* Delete Confirmation */}
      {isDeleteConfirmationVisible && (
        <ConfirmationPopup
          message="هل أنت متأكد من رغبتك في حذف هذه الفئة؟ لا يمكن التراجع عن هذا الإجراء."
          onConfirm={handleDeleteConfirm}
          onCancel={handleDeleteCancel}
        />
      )}
    </div>
  );
};

export default CategoryPopup;